<script lang="ts" setup>
import type { HomePageProcess } from '~/models/homepage';
import useI18NAsync from '~/composables/i18nAsync';

import vuBtn from '@ds/vuekit/src/components/vu-btn.vue';
import vuIcon from '@ds/vuekit/src/components/vu-icon.vue';

const i18n = useI18NAsync('homepage');
const i18nPF = useI18NAsync('process_families');

export interface Props {
  processes: HomePageProcess[];
  isMobileDevice?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  processes: () => [] as HomePageProcess[],
  isMobileDevice: false,
});
const emit = defineEmits(['clickBtn', 'clickLabel', 'processIconClicked']);
</script>
<template>
  <div class="process-families">
    <!-- Default mode -->
    <div class="process-families grid grid-5-columns pa-12px" v-if="!isMobileDevice">
      <div
        v-for="process in props.processes"
        :key="process.id"
        class="white grey-7--text flex align-items-center justify-center top-card grid-gap-10px text-center process-card subtitle"
        @click="emit('clickLabel', process)"
      >
        <vu-icon :icon="process.icon" @click="emit('processIconClicked', process)" />
        <i18nPF :ikey="process.name" />
      </div>
      <vu-btn
        v-for="process in props.processes"
        :key="process.id"
        color="primary"
        class="text--uppercase"
        @click="emit('clickBtn', process)"
      >
        <i18n :ikey="'getAQuote'" />
      </vu-btn>
    </div>
    <!-- Mobile -->
    <div
      v-if="isMobileDevice"
      class="process-families-mobile process-families-small-screen relative pb-10px"
    >
      <template v-for="(process, index) in props.processes" :key="`${process.name}--mobile`">
        <div class="flex flex-important align-items-center process px-10px--sm px-30px py-8px">
          <div class="flex-grow-1" @click="emit('clickLabel', process)">
            <vu-icon :icon="process.icon" class="left-icon mr-20px" />
            <span class="text-content">
              <i18nPF :ikey="process.name" />
            </span>
          </div>
          <vu-icon
            icon="shopping-cart"
            color="white--text"
            class="btn btn-primary"
            @click="emit('clickBtn', process)"
          />
        </div>
        <div v-if="index + 1 !== props.processes.length" :key="process.id" class="divider" />
      </template>
      <div class="bottom-divider" />
    </div>
  </div>
</template>
<style lang="css" scoped>
.process-families {
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
  gap: 4px 12px;
}

.process-card {
  height: 60px;
  border-radius: 5px;
  padding: 0 15px;
}

.process-families-mobile {
  font-size: 18px;
  background-color: white;
}

.divider {
  background: #e2e4e3;
  width: 100%;
  height: 2px;
}

.bottom-divider {
  border-top: 20px solid white;
  border-left: 50vw solid transparent;
  border-right: 50vw solid transparent;
  bottom: -19px;
  position: absolute;
  margin: auto;
  filter: drop-shadow(0 7px 3px rgba(0, 0, 0, 0.1));
}
</style>
